import { Capacitor } from "@capacitor/core";
import { ReactElement, useEffect, useState } from "react";

import SignIn from "./sign-in";

export default function Home(): ReactElement {
  const [, setPlatform] = useState<string | null>(null);

  useEffect(() => {
    setPlatform(Capacitor.getPlatform());
  }, []);

  return (
    <div className="flex items-center h-screen w-screen bg-[rgba(50,50,50,0.9)]">
      <SignIn />
    </div>
  );
}
